import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { PromoCodeManagement } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/promo-codes")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <PromoCodeManagement />
    </RouteGuard>
  ),
});
